import React from 'react'
import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core'

import { Generic } from 'src/api/models'

interface SkuSelectionCardProps {
  skus: Generic[]
  select: (sku: Generic) => void
}

export const SkuSelectionCard = (props: SkuSelectionCardProps) => {
  const { skus, select } = props
  return (
    <Card>
      <CardContent>
        <Typography variant="h1">Select the SKU:</Typography>
        <Grid container spacing={2}>
          {skus.map((sku) => (
            <Grid item key={sku.object.guid}>
              <Button variant="contained" onClick={() => select(sku)}>
                {sku.object.sku} [{sku.object.client.name}]
              </Button>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  )
}
